// extracted by mini-css-extract-plugin
export default {"modalHeader":"announcements_modalHeader__W8KeQ","bannerHeader":"announcements_bannerHeader__rZSaf","cfnImage":"announcements_cfnImage__2vuVN"};